import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const AlertIcon = (
    props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
    <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{
            width: '24px',
            height: '24px',
            margin: '0 10px',
            color: 'gray',
        }}
        {...props}
    >
        <title>{"Alert"}</title>
        <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g id="Alert">
                <rect
                    id="Rectangle"
                    fillRule="nonzero"
                    x={0}
                    y={0}
                    width={24}
                    height={24}
                />
                <line
                    x1={12}
                    y1={13}
                    x2={12}
                    y2={9}
                    id="Path"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                />
                <line
                    x1={12}
                    y1={16.5}
                    x2={12}
                    y2={16.63}
                    id="Path"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                />
                <path
                    d="M10.2679,5.0000025 C11.0377,3.66667 12.9622,3.66667 13.732,5.0000025 L20.6602,17.0000025 C21.43,18.3333 20.4678,20.0000025 18.9282,20.0000025 L5.07177,20.0000025 C3.53217,20.0000025 2.56992,18.3333 3.33972,17.0000025 L10.2679,5.0000025 Z"
                    id="Path"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                />
            </g>
        </g>
    </svg>
);
export default AlertIcon;
